import { Add } from '@mui/icons-material';
import { Typography } from '@mui/material';
import React, { useRef, useState } from 'react';
import { Button } from 'react-bootstrap';

const FileUploadJira = ({ enableDragAndDrop, loading, handleFiles }) => {
  const [isDragging, setIsDragging] = useState(false);
  const [error, setError] = useState(null);
  const fileInputRef = useRef(null);
  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = Array.from(e.dataTransfer.files);
    setError(null);
    handleFiles(files);
  };

  const handleFileChange = (e) => {
    setError(null);
    const files = Array.from(e.target.files);
    handleFiles(files);
  };

  const handleChooseFiles = () => {
    fileInputRef.current.click();
  };

  return loading ? (
    <p style={{ textAlign: 'center', padding: '1rem' }}>Uploading...</p>
  ) : (
    <div>
      {enableDragAndDrop ? (
        <div
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          onClick={handleChooseFiles}
          style={{
            border: isDragging ? '2px dashed #007bff' : '2px dashed #cccccc',
            padding: '20px',
            textAlign: 'center',
            marginBottom: '20px',
            cursor: 'pointer',
            backgroundColor: isDragging ? '#f8f9fa' : 'transparent',
          }}>
          <p className="text-muted">Drag & drop or click to select files</p>
        </div>
      ) : (
        <Button
          size="sm"
          variant=""
          className="me-2"
          onClick={handleChooseFiles}>
          <Add /> Attach files
        </Button>
      )}
      <input
        type="file"
        multiple
        onChange={handleFileChange}
        style={{ display: 'none' }}
        ref={fileInputRef}
      />
      {error && (
        <Typography variant="caption" color="error">
          {error}
        </Typography>
      )}
    </div>
  );
};

export default FileUploadJira;
